import { MouseEventHandler } from 'react';

import { ArrowBackIcon, ArrowForwardIcon } from '@repo/ui/icons';

type ArrowButtonProps = {
  direction: 'left' | 'right';
  onClick: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  className?: string; // styled-components className
  iconColor?: string; // icon color for icon
};

export default function ArrowButton({
  direction,
  onClick,
  disabled = false,
  className,
  iconColor = '#000000',
}: ArrowButtonProps) {
  return (
    <button onClick={onClick} className={className} disabled={disabled}>
      {direction === 'left' ? (
        <ArrowBackIcon color={iconColor} size={20} />
      ) : (
        <ArrowForwardIcon color={iconColor} size={20} />
      )}
    </button>
  );
}
